import React, { useContext } from "react"
import { PCViewContext } from "../Common/PCViewContext"
import * as styles from "./Styles/Title.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

export default (props) => {
  const isPC = useContext(PCViewContext)

  let locationName = "全国"
  if (props.city) {
    locationName = props.city.name
  } else if (props.prefecture) {
    locationName = props.prefecture.name
  }
  const categoryName = props.category ? props.category.name : "お店・施設"
  return (
    <h1 className={cn("title", isPC ? "pc" : "sp")}>
      {locationName}の{categoryName}
    </h1>
  )
}
